<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/site/header.png">
    <div class="app-container">
      <router-view/>
    </div>
    <div class="comic-footer">
      <div class="footer-filler"></div>
      <div class="copyright">Copyright  ©1986-2019 Peta Hewitt Australia All Rights Reserved.</div>
    </div>
    </div>
</template>

<script>

export default {
  name: 'app',
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  margin-top: 60px;
}
.app-container{
  background-color: #D66555;
  position: relative;
  width: 990px;
  margin: auto;
  margin-top: -4px;
}
.comic-footer{
  display: block;
  height:100px;
  width:990px;
  border-radius: 0 0  50px 50px;
  background-color:#2c3e50;
  margin: auto;
}
.footer-filler{
  height:70px;
}
.copyright{
  color:#FEFDD3;
  width:500px;
  margin: auto;
  text-align: center;
  font-size:0.7em;
}
</style>
